/** Filters a staff moderation list applies from its URL, in the shape `useRestData().activeFilters` takes. */
export type ModerationListFilters = Record<string, string | boolean | { v: string; op: string }>

type RouteQuery = Record<string, unknown>

// vue-router gives string | string[] | null per key; take the first value.
function firstString(value: unknown): string {
  const first = Array.isArray(value) ? value[0] : value
  return typeof first === 'string' ? first : ''
}

/**
 * Reads the dashboard's drill-down links (RF-067): `?createdAfter=<iso>` and `?open=1` (an open bounty is
 * approved, unclaimed and not yet expired) on top of the older `id`, `userProfileId` and `moderationStatus`. RF-070 adds
 * `crashLinkStatus` (for example `?crashLinkStatus=Pending`, the reports whose crash link still needs a decision).
 * `now` is passed in so the result is deterministic.
 */
export function moderationListFilters(query: RouteQuery, now: Date): ModerationListFilters {
  const filters: ModerationListFilters = {}

  for (const key of ['id', 'userProfileId', 'moderationStatus', 'crashLinkStatus']) {
    const value = firstString(query[key])
    if (value) filters[key] = value
  }

  const createdAfter = firstString(query.createdAfter)
  if (createdAfter && !Number.isNaN(Date.parse(createdAfter))) {
    filters.createdAt = { v: createdAfter, op: 'gte' }
  }

  if (firstString(query.open) === '1') {
    filters.moderationStatus = 'Approved'
    filters.isClaimed = false
    filters.expiresAt = { v: now.toISOString(), op: 'gt' }
  }

  return filters
}
